import React from 'react';

import { Box, Skeleton } from '@rbilabs/universal-components';

import LoadingAnimation from 'components/loading-animation';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';

const SKELETON_IMAGE_WIDTH = '132px';
const SKELETON_ROW_HEIGHT = '112px';

const MenuTileSkeleton = () => {
  return (
    <Box
      flexDirection="row"
      width="full"
      padding={{ base: '$4', md: '$2' }}
      height={SKELETON_ROW_HEIGHT}
    >
      <Box width={SKELETON_IMAGE_WIDTH}>
        <Skeleton rounded="md" flex={1} />
      </Box>
      <Box flex={1} justifyContent="center" padding="$4">
        <Skeleton width="85%" height="$4" rounded="md" />
      </Box>
    </Box>
  );
};

export const MenuSkeletonLoader = () => {
  const isMobile = useIsMobileBreakpoint();

  if (isMobile) {
    return (
      <>
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
      </>
    );
  }

  return <LoadingAnimation />;
};
